import "./App.css";
import Announcement from "./components/annoucement";
import Feewaiver from "./pages/Feewaiver";
import { Routes, Route, Navigate } from 'react-router-dom'
import Home from "./Home";
import About from './pages/About'
import Resources from "./pages/Resources";
import Navbar from "./Navbar";
import Footer from "./Footer";
import PageNotFound from "./PageNotFound";
import RouteSeo from "./components/RouteSeo";
import Directory from "./pages/Directory"
import TermOfService from "./TermOfService";
import MediaContact from "./pages/MediaContact";
import MediaKit from "./pages/MediaKit"; 
import WinnersFour from "./pages/WinnersFour";
import StartIROClub from "./pages/StartIROClub";
import RulesandRegulations from "./pages/RulesandRegulations";
import Reviewandvideos from "./pages/Reviewandvideos";
import RegistrationandEligibility from "./pages/RegistrationandEligibility";
import PressReleases from "./pages/PressReleases"; 
import PracticeExams from "./pages/PracticeExams";
import AboutIRO from "./pages/AboutIRO";
import News from "./pages/News"
import Winners from "./pages/Winners";
import WinnersTwo from "./pages/WinnersTwo";
import WinnersThree from "./pages/WinnersThree";
import WinnersHub from "./pages/WinnersHub";
import SemiCurriculum from "./pages/SemiCurriculum";
import StudentAmbassador from "./pages/StudentAmbassador";
import ClubByLaws from "./pages/ClubByLaws";
import ClubPresentationSlides from "./pages/ClubPresentationSlides";
// Textbook archived (no longer sold/publicised) — restore this import + route to bring it back.
// import Textbook from "./pages/Textbook";
import OpensResultsAndHonorRollReleased from "./components/Opens-results-and-honor-roll-released";
import DistinguishedScholar from "./pages/DistinguishedScholar";
import Semifinalists from "./pages/Semifinals";
import FAQ from "./pages/FAQ";
import StatsPreview from "./pages/StatsPreview";
import ScienceCommunicatorAward from "./pages/ScienceCommunicatorAward";
import FinalMocks2026 from "./pages/FinalMocks2026";
import FinalResults2026 from "./pages/FinalResults2026";
import FinalsGallery2026 from "./pages/FinalsGallery2026";
import Certificate2026 from "./pages/Certificate2026";


function App() {

  return (
    <div className="App">
      <div className="app">

        <>
              <RouteSeo />
              <Navbar />
              <Announcement />
              <Routes>
              
                <Route path="/" element={<Home />} />
                {/* <Route path="/textbook" element={<Textbook/>}/> */}
                <Route path='/about' element={<About/>} />
                <Route path='/resources' element={<Resources/>} />
                {/* /login + /register retired 2026-06 (Firebase auth removed) */}
                <Route path='/2025-finalists' element={<WinnersFour />} />
                <Route path='/terms-of-service' element={<TermOfService />} />
                <Route path='/media-contact' element={<MediaContact />} />
                <Route path='/fee-waiver-form' element={<Feewaiver/>} />
                <Route path='/media-kit' element={<MediaKit />} />
                <Route path='/finalists' element={<WinnersTwo />} />
                <Route path='/winners' element={<WinnersThree />} />
                <Route path='/semis-results' element={<Winners />} />
                <Route path='/winners-hub' element={<WinnersHub />} />
                <Route path='/iro-in-the-news' element={<News />} />
                <Route path='/start-iro-club' element={<StartIROClub />} />
                <Route path='/clubs' element={<StartIROClub />} />
                <Route path='/rules-and-regulations' element={<RulesandRegulations />} />
                <Route path='/semi-curriculum' element={<SemiCurriculum />} />
                <Route path='/curriculum' element={<Reviewandvideos />} />
                <Route path='/registration-and-eligibility' element={<RegistrationandEligibility />} />
                <Route path='/press-releases' element={<PressReleases />} />
                <Route path='/practice-exams' element={<PracticeExams />} />
                {/* Old practice pages merged into /practice-exams */}
                <Route path='/mocks' element={<Navigate to="/practice-exams" replace />} />
                <Route path='/semifinal-practice-exams' element={<Navigate to="/practice-exams" replace />} />
                <Route path='/2026-practice-exams' element={<Navigate to="/practice-exams" replace />} />
                <Route path='/about-iro' element={<AboutIRO />} />
                <Route path='/forms/student-ambassador' element={<StudentAmbassador />} />
                <Route path='/files/club-bylaws' element={<ClubByLaws />} />
                <Route path='/files/club-presentation-slides' element={<ClubPresentationSlides />} />
                <Route path='/directory' element={<Directory />} />
                <Route path='/opens-results-and-honor-roll-released' element={<OpensResultsAndHonorRollReleased />} />
                <Route path='/distinguished-scholar' element={<DistinguishedScholar />} />
                <Route path='/semifinalists' element={<Semifinalists />} />
                <Route path='/faq' element={<FAQ />} />
                <Route path='/stats-preview' element={<StatsPreview />} />
                <Route path='/science-communicator-award' element={<ScienceCommunicatorAward />} />
                <Route path='/2026-final-mocks' element={<FinalMocks2026 />} />
                <Route path='/2026-final-results' element={<FinalResults2026 />} />
                <Route path='/2026-finals-gallery' element={<FinalsGallery2026 />} />
                <Route path='/certificate' element={<Certificate2026 />} />
                <Route path='/2026-certificate' element={<Certificate2026 />} />
                <Route path='*' element={<PageNotFound />} />

              </Routes>

              <Footer />

            </>

      </div>
    </div>
  );
}

export default App;
